<template>
  <Page>
    <Table />
  </Page>
</template>

<script setup>

  import Page from "@/components/Page.vue";
  import Table from "./Table.vue";

</script>

<style scoped>

</style>